import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { DialogSelectOptionComponent } from '@app/_modules/general-configurations/dialogs/dialog-select-option/dialog-select-option.component';
import { GeneralConfigService, ListenFirebaseService, ShowMessage, TenantManagerService } from '@app/_services';
import { DialogDeleteComponent } from '@app/_shared/dialogs/delete/dialog-delete.component';
import { MESSAGE_ERROR_CALL_API, TIME_OUT_LISTEN_FIREBASE } from '@app/_shared/utils/constant';
import { Subscriber } from 'rxjs';
import { Observable } from 'rxjs/internal/Observable';

@Component({
  selector: 'app-tab-integrated-elsa',
  templateUrl: './tab-integrated-elsa.component.html',
  styleUrls: ['./tab-integrated-elsa.component.scss']
})
export class TabIntegratedElsaComponent implements OnInit {
  formSubmit: FormGroup;
  listTenants: any = [];
  isLoading: boolean = false;
  keyword: string = '';
  isCreate: boolean = false;
  listDVGDs: any = [];

  constructor(
    public dialog: MatDialog,
    private tenantManagerService: TenantManagerService,
    private generalConfigService: GeneralConfigService,
    private showMessage: ShowMessage,
    private listenFirebaseService: ListenFirebaseService,
    private fb: FormBuilder,
  ) { }

  ngOnInit(): void {
    this.formSubmit = this.fb.group({
      items: this.fb.array([]),
    });
    this.getListTenants();
    this.getListConfigs();

  }

  get items() { return (this.formSubmit.get('items') as FormArray) }

  createDynamicForm(value = null) {
    return this.fb.group({
      id: value ? value.id : null,
      tenantId: [value?.tenantId ? value?.tenantId : '', Validators.required],
      moetId: [value?.organizationId ? value?.organizationId : '', Validators.required],
      moetName: value?.organizationName ? value?.organizationName : 'Chọn ĐVND/ĐVGD',
      status: value ? Boolean(value.status) : true,
      api_key: [value?.apiKey ? value?.apiKey : '', Validators.required],
      checkValidate: false,
      disableControl: value ? true : false,
      isCanEditControl: value ? true : false
    });
  }

  delete(index: number, id) {
    const dialogRef = this.dialog.open(DialogDeleteComponent, {
      height: 'auto',
      width: '35%',
      data: {
        title: 'Bạn đang thực hiện xóa cấu hình',
        message: 'Bạn có chắc muốn xóa cấu hình này không ?',
        btnOkText: 'XÓA',
        btnCancelText: 'HỦY',
        data: {
          name: ``
        },
      }
    })
    dialogRef.afterClosed().subscribe((ref: any) => {
      if (ref) {
        let dataInput = {
          id: id
        }
        this.listenFireBase('delete', index);
        this.setTimOutFireBase();
        this.generalConfigService.deleteIntegratedElsaConfig(dataInput).subscribe((res: any) => {
          if (res.status == 0) {
            this.isLoading = false;
            this.showMessage.error(res.msg);
          }
        }, (err: any) => {
          this.isLoading = false;
          this.showMessage.error(MESSAGE_ERROR_CALL_API);
        });
      }
    });

  }

  update(index) {
    this.items.controls[index].get('disableControl').setValue(!this.items.controls[index].get('disableControl').value);
  }

  add() {
    this.items.push(this.createDynamicForm());
    this.isCreate = true;
  }

  submit(index, valueRow) {
    this.isLoading = true;

    if (valueRow.get('tenantId').value == '' || valueRow.get('tenantId').value == null) {
      this.isLoading = false;
      return this.showMessage.warring('Bạn chưa chọn khách hàng!');
    }
    if (valueRow.get('moetId').value == '' || valueRow.get('moetId').value == null) {
      this.isLoading = false;
      return this.showMessage.warring('Bạn chưa chọn đơn vị ngành dọc hoặc đơn vị giáo dục!');
    }
    if (valueRow.get('api_key').value == '' || valueRow.get('api_key').value == null) {
      this.isLoading = false;
      return this.showMessage.warring('Bạn chưa nhập api key!');
    }

    // if (this.formSubmit.invalid) {
    //   this.isLoading = false;
    //   return;
    // }
    if (this.isCreate && !valueRow.get('isCanEditControl').value) {
      // create
      let dataInput: any = {
        tenantId: valueRow.get('tenantId').value ? valueRow.get('tenantId').value : valueRow.get('dvgdId').value,
        organizationId: valueRow.get('moetId').value,
        status: valueRow.get('status').value ? 1 : 0,
        apiKey: valueRow.get('api_key').value,
      }
      this.listenFireBase('create', index);
      this.setTimOutFireBase();
      this.generalConfigService.addIntegratedElsaConfig(dataInput).subscribe((res: any) => {
        if (res.status == 0) {
          this.isLoading = false;
          this.showMessage.error(res.msg);
        }
      }, (err: any) => {
        this.isLoading = false;
        this.showMessage.error(MESSAGE_ERROR_CALL_API);
      })
    } else {
      // update
      let dataInput: any = {
        id: valueRow.get('id').value,
        status: valueRow.get('status').value ? 1 : 0,
        apiKey: valueRow.get('api_key').value
      }
      this.listenFireBase('update', index);
      this.setTimOutFireBase();
      this.generalConfigService.editIntegratedElsaConfig(dataInput).subscribe((res: any) => {
        if (res.status == 0) {
          this.isLoading = false;
          this.showMessage.error(res.msg);
        }
      }, (err: any) => {
        this.isLoading = false;
        this.showMessage.error(MESSAGE_ERROR_CALL_API);
      })
    }
  }

  clear(index: number) {
    this.items.removeAt(index);
  }

  // chon dvnd hoac dvgd
  chooseOption(index) {
    const dialogRef = this.dialog.open(DialogSelectOptionComponent, {
      height: 'auto',
      width: '40%',
    })
    dialogRef.afterClosed().subscribe((ref: any) => {
      if(ref != undefined && ref) {
        this.items.controls[index].get('moetId').setValue(ref?.id);
        this.items.controls[index].get('moetName').setValue(ref?.name);
      }
    })
  }

  // lấy danh sách khách hàng
  getListTenants() {
    this.tenantManagerService.getDataTenant(99999, 0, '', []).subscribe((res: any) => {
      this.listTenants = res.data.data;
    }, (err: any) => {

    })
  }

  // lay danh sach cau hinh
  getListConfigs() {
    this.items.controls = [];
    this.generalConfigService.getListIntegratedElsaConfig({ "keyword": this.keyword }).subscribe((res: any) => {
      res.data.forEach(element => {
        this.items.push(this.createDynamicForm(element));
      });
    }, (err: any) => {

    })
  }

  listenFireBase(action, index) {
    const listenFb = new Observable((subscriber: Subscriber<any>) => {
      this.listenFirebaseService.checkFireBase(action, 'admin_config', subscriber);
    });
    listenFb.subscribe((ref) => {
      if (ref === true) {
        switch (action) {
          case 'create':
            this.isCreate = false;
            // this.items.controls[index].get('disableControl').setValue(true);
            // this.items.controls[index].get('isCanEditControl').setValue(true);
            this.getListConfigs();
            break;
          case 'update':
            // this.items.controls[index].get('disableControl').setValue(true);
            this.getListConfigs();
            break;
          case 'delete':
            // (this.formSubmit.get('items') as FormArray).removeAt(index);
            this.getListConfigs();
            break;
        }
        this.isLoading = false;
      } else {
        this.isLoading = false;
      }
    });
  }

  setTimOutFireBase() {
    setTimeout(() => {
      if (this.isLoading) {
        this.isLoading = false;
      }
    }, TIME_OUT_LISTEN_FIREBASE);
  }
}
